import call from './call';
import handleBase64ZipResponse from "../helpers/handleBase64ZipResponse";

export default (filters,onFinishCallback,onErrorCallBack) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result)
        {
            if(result[1].success)
            {
                let file=result[1].result;
                if(file)
                    handleBase64ZipResponse(file, "certs.csv");
                else if(onFinishCallback)
                    onFinishCallback(result[1]);
            }
            else
                onErrorCallBack();
        }
    };
    dispatch(call("CertificateService/getAllCertificates",filters,onResult));
};